module.exports = __webpack_public_path__ + "static/img/app-logo.32c528d6.png";